export default "__VITE_PUBLIC_ASSET__ba060062__"